export default __webpack_public_path__ + "static/careers-diversity-footer-994ee38a869d35610e3b4bbb76ae4f1b.svg";